import { DateInput, DateInputProps } from "@progress/kendo-react-dateinputs";
import * as React from "react";

interface CustomDateTimeInputProps extends DateInputProps {
    isDefaultValue?: boolean;
}

export const CustomDateTimeInput: React.FC<CustomDateTimeInputProps> = (props: CustomDateTimeInputProps) => {
    return (
        <DateInput
            format="dd/MM/yyyy HH:mm"
            valid={true}
            required={false}
            value={props.isDefaultValue ? null : props.value}
            onChange={props.onChange} />
    );
};
